import { createFileRoute } from '@tanstack/react-router';
import { ReimbursementAnalyticsPage } from '@/features/reimbursements/components/ReimbursementAnalyticsPage';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/reimbursements/analytics')({
  component: ReimbursementAnalyticsRoute,
});

function ReimbursementAnalyticsRoute() {
  const { hasPermission } = usePermissions();
  if (!hasPermission(Permission.REIMBURSEMENTS_VIEW_ANALYTICS)) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">
          Você não tem permissão para acessar esta página.
        </p>
      </div>
    );
  }
  return <ReimbursementAnalyticsPage />;
}
